import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { type AccessGrant, useUpdateAccessGrant } from "@/hooks/use-access";
import { useSession } from "@/lib/auth-client";
import { AccessGrantForm } from "./AccessGrantForm";

export function EditAccessDialog({
  open,
  onOpenChange,
  grant,
}: {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  grant: AccessGrant;
}) {
  const update = useUpdateAccessGrant();
  // Nobody changes their own level (the server refuses it too).
  const { data: session } = useSession();
  const isSelf = session?.user?.email?.toLowerCase() === grant.email;

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle>Edit access</DialogTitle>
          <DialogDescription>
            {isSelf
              ? "You can edit your own title. Another admin has to change your level."
              : "A new level applies from their next page load. No need to sign them out."}
          </DialogDescription>
        </DialogHeader>
        <AccessGrantForm
          emailLocked
          levelLocked={isSelf}
          submitLabel="Save"
          isSaving={update.isPending}
          defaultValues={{ email: grant.email, level: grant.level, title: grant.title ?? "" }}
          onCancel={() => onOpenChange(false)}
          onSubmit={(values) => {
            const title = values.title || null;
            const level = values.level !== grant.level ? values.level : undefined;
            const titleChanged = title !== grant.title;
            if (!level && !titleChanged) {
              onOpenChange(false);
              return;
            }
            update.mutate(
              { grant, level, title: titleChanged ? title : undefined },
              { onSuccess: () => onOpenChange(false) },
            );
          }}
        />
      </DialogContent>
    </Dialog>
  );
}
